import { useDispatch, useSelector } from 'react-redux';
import * as ReportGenerationStore from '../../../../redux/reportGeneration';
import type { ReportFormatType } from '../shared/types';

/**
 * A hook that returns a function that will force a re-render of the report preview panel
 * @returns {() => Promise<void>} - A function that will force a re-render of the report
 */
export const useForceReportReRender = () => {
  const dispatch = useDispatch();
  const format = useSelector(ReportGenerationStore.selectors.getFormat);

  return async () => {
    // This is a little hacky - we change the format to force a re-render of the report
    // TODO - move this into the HTML preview component when that is refactored
    const ogFormat = format;
    await dispatch(ReportGenerationStore.actions.setFormat('' as ReportFormatType));
    await dispatch(ReportGenerationStore.actions.setFormat(ogFormat));
  };
};
